import React, { Component } from 'react';

// import PropTypes from 'prop-types';

import styles from './ScoreCard.module.scss';

const returnRandomGrade = () => {
  const generated = Math.floor(Math.random() * 2) + 1;
  let grade;
  switch(generated) {
    case(1):
       grade = 'A';
       break;
    case(2):
       grade = 'B';
       break;
    default:
       grade = 'A';
       break;
  }
  return grade;
}

const returnColorGrade = (grade) => {
  let color;
  switch(grade) {
    case('A'):
      color = '#00A064';
      break;
    case('B'):
      color = '#91BE23';
      break;
    default:
      color = '#00A064';
  }
  return color;
}

class ScoreCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mainGrade: returnRandomGrade(),
      trafficGrade: returnRandomGrade(),
      conversionGrade: returnRandomGrade(),
      productGrade: returnRandomGrade(),
      operationsGrade: returnRandomGrade(),
    }
  }

  render() {
    const { mainGrade, trafficGrade, conversionGrade, productGrade, operationsGrade }  = this.state;
    return (
      <div className={styles.scoreCardWrapper}>
        <div className={styles.scoreCardContainer}>
          <div
            style={{ backgroundColor: returnColorGrade(mainGrade)}}
            className={styles.performanceContainer}
          >
            <span>My Performance</span>
              <p>{mainGrade}</p>
            <span>+2.3M</span>
          </div>
          <svg id={styles.topLine}>
            <line x1="-7" y1="-15" x2="35" y2="70" stroke="#179F66" strokeWidth="1" />
          </svg>
          <svg id={styles.bottomLine}>
            <line x1="0.1" y1="100%" x2="30" y2="90" stroke="#179F66" strokeWidth="1" />
          </svg>
          <div className={styles.breakdownContainer}>
            <div
              style={{ backgroundColor: returnColorGrade(trafficGrade)}}
              className={styles.itemContainer}
            >
              <p>Traffic</p>
              <div>
                <span style={{
                  backgroundColor: trafficGrade !== 'A' ? '#F1F1F1' : null,
                  color: trafficGrade !== 'A' ? '#0D0D0D' : null
                  }}>
                    {trafficGrade}
                </span>
              </div>
            </div>
            {/* HARDCODED FOR DEMONSTRATION PURPOSES */}
            <div
              style={{ backgroundColor: returnColorGrade(conversionGrade)}}
              className={styles.itemContainer}
            >
              <p>Conversion</p>
              <div>
                <span style={{
                  backgroundColor: conversionGrade !== 'A' ? '#F1F1F1' : null,
                  color: conversionGrade !== 'A' ? '#0D0D0D' : null
                  }}>
                    {conversionGrade}
                </span>
              </div>
            </div>
            <div
              style={{ backgroundColor: returnColorGrade(productGrade)}}
              className={styles.itemContainer}
            >
              <p>Product</p>
              <div>
                <span style={{
                  backgroundColor: productGrade !== 'A' ? '#F1F1F1' : null,
                  color: productGrade !== 'A' ? '#0D0D0D' : null
                  }}>
                    {productGrade}
                </span>
              </div>
            </div>
            <div
              style={{ backgroundColor: returnColorGrade(operationsGrade)}}
              className={styles.itemContainer}
            >
              <p>Operations</p>
              <div>
                <span style={{
                    backgroundColor: operationsGrade !== 'A' ? '#F1F1F1' : null,
                    color: operationsGrade !== 'A' ? '#0D0D0D' : null
                  }}>
                    {operationsGrade}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ScoreCard;
